import { render, staticRenderFns } from "./SubmitBlock.vue?vue&type=template&id=1d7e90c4&"
import script from "./SubmitBlock.vue?vue&type=script&lang=js&"
export * from "./SubmitBlock.vue?vue&type=script&lang=js&"
import style0 from "./SubmitBlock.vue?vue&type=style&index=0&id=1d7e90c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports